import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

//Components
import SucursalesIndex from '../SucursalesIndex/SucursalesIndex'

//MUI
import { Box, Divider, FormControl, IconButton, InputLabel, MenuItem, Select } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear';

const SucursalesIndexList = () => {
    const { states, branches, fetched } = useSelector(state => state.shop);

    const [item, setItem] = useState([]);
    const [stateInput, setStateInput] = useState('');

    useEffect(() => {
        if (fetched)
            setItem(branches);
    }, [branches, fetched])

    const handleStateChange = (e) => {
        setStateInput(e.target.value)
    }

    const applyFilters = () => {
        let updatedList = branches;

        if (stateInput) {
            updatedList = updatedList.filter(
                (item) =>
                    item.state === stateInput
            );
        }

        setItem(updatedList);
    };

    useEffect(() => {
        if (stateInput)
            applyFilters();
    }, [stateInput])

    const handleClear = () => {
        setItem(branches);
        setStateInput('');
    };

    return (
        <>
            <Box className='index_select'>
                <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Seleccione su estado</InputLabel>
                    <Select
                        label='Seleccione su estado'
                        value={stateInput}
                        onChange={handleStateChange}
                        displayEmpty
                        sx={{
                            "& .MuiSelect-iconOutlined": { display: stateInput ? 'none' : '', color: '#56C596' },
                            "&.Mui-focused .MuiIconButton-root": { color: '#56C596' },
                        }}
                        endAdornment={<IconButton sx={{ visibility: stateInput ? "visible" : "hidden" }}
                        onClick={handleClear}><ClearIcon /></IconButton>}
                    >
                        {
                            states.map((res, index) =>
                                <MenuItem key={index}
                                    value={res}>
                                    {res}
                                </MenuItem>
                            )
                        }
                    </Select>
                </FormControl>
            </Box>
            <Box sx={{ p: 2, border: '1px solid #56C596', borderRadius: '20px', boxShadow: 'rgba(50, 157, 156, 0.35) 0px 5px 15px' }}>
                <div className="scroll">
                    {
                        item.length > 0
                            ?
                                item.map((res) => (
                                    <div key={res.url}>
                                        <SucursalesIndex res={res} />
                                        <Divider sx={{ my: 2.5 }} />
                                    </div>
                                ))
                            
                            :
                            <>No hay resultados</>
                    }
                </div>
            </Box>
        </>
    );
};

export default SucursalesIndexList;